import React from "react";
import cs from "classnames";

import { PRODUCT_STORE_FILTERS } from "./ProductStore.catalog";
import { ProductStoreCategory } from "./ProductStore.types";

interface Props {
  selected: ProductStoreCategory;
  onChange: (category: ProductStoreCategory) => void;
}

export const ProductStoreFilters = ({ selected, onChange }: Props) => (
  <nav className="ProductStoreFilters" aria-label="Quick filters">
    {PRODUCT_STORE_FILTERS.map((filter) => (
      <button
        className={cs("ProductStoreFilters__button", {
          "ProductStoreFilters__button--active": selected === filter.id,
        })}
        type="button"
        aria-pressed={selected === filter.id}
        aria-controls="product-store-results"
        key={filter.id}
        onClick={() => onChange(filter.id)}
      >
        {filter.label}
      </button>
    ))}
  </nav>
);
